import type { Floor } from '@/types/home.type'
import type { ShopInfo } from '@/types/shop-info'
import { request } from '@/utils'
import { BaseService } from './base.service'

export default class HomeService extends BaseService {
  // 查询店铺配置
  getShopInfos(cityId: string = '3101') {
    return request.httpGet<ShopInfo>(`${this.homePrefix}/pub/v3/shop/configs?cityId=${cityId || ''}`)
  }
  // 查询首页楼层信息
  getFloorInfos(params: { cityId?: string, page?: string, id?: string }) {
    const { cityId, page, id } = params || {}
    // return request.httpGet<Floor[]>(`${this.homePrefix}/pub/v3/floors?cityId=${cityId || ''}`)
    const query = id ? `cityId=${cityId}&page=${page}&id=${id}` : `cityId=${cityId}&page=${page}`
    return request.httpGet<Floor>(`${this.homePrefix}/pub/v5/layouts?${query}`)
  }
}
